import Vue from 'vue'
import VueRouter from 'vue-router'
import Shop from '../views/shop/index.vue'
import Verify from '../views/verify/verify.vue'
import Rules from '../views/rules/rules.vue'
import Activity from '../views/activity/activity.vue'
import AddActivity from '../views/activity/addActivity.vue'
import Zp from '../views/zp/zp.vue'
import Addposition from '../views/zp/addposition.vue'
import pubSuccess from '../views/success/pubsuccess.vue'
import acEdit from "../views/activity/EditActivity.vue"
import poEdit from "../views/zp/editPosition.vue"
import Service from "../views/service/service.vue"
import addService from "../views/service/addService.vue"
import editService from "../views/service/editService.vue"
import Company from "../views/company/company.vue"
import Resume from "../views/zp/resume.vue"
import Acform from "../views/activity/form.vue"
import Acinfo from "../views/activity/info.vue"
import getCode from "../views/getCode.vue"
import Channel from "../views/activity/channel.vue"
import index from "../views/index/index.vue"
import searchResult from "../views/index/searchResult.vue"
import signList from "../views/index/activity/list.vue"
import signDetail from "../views/index/activity/detail.vue"
import signUp from "../views/index/activity/signup.vue"
import company from "../views/index/activity/company.vue"
import Live from "../views/index/live/list.vue"
import livemore from "../views/index/live/checkmore.vue"
import liveDetail from "../views/index/live/detail.vue"
import hr from "../views/index/hr/index.vue"
import coach from "../views/index/coach/index.vue"
import coachDetail from "../views/index/coach/detail.vue"
import homeSuccess from "../views/index/success.vue"
import certification from "../views/index/certification/index.vue"
import cerDetail from "../views/index/certification/detail.vue"
import education from "../views/index/education/index.vue"
import eduDetail from "../views/index/education/detail.vue"
import serviceIndex from "../views/index/buygoods/index.vue"
import serviceDetail from "../views/index/buygoods/detail.vue"
import books from "../views/index/books/index.vue"
import bookDetail from "../views/index/books/detail.vue"
import Recruitment from "../views/index/recru/index.vue"
import RecruitmentDetail from "../views/index/recru/detail.vue"
import Companyhr from "../views/index/recru/company.vue"
import mine from "../views/mine/index.vue"
import bookOrderDetail from "../views/mine/bookOrderDetail.vue"
import activityOrderDetail from "../views/mine/aorderdetail.vue"
import newsList from "../views/index/newsList.vue"
import newsDetail from "../views/index/newsDetail.vue"
import recommand from "../views/index/recommand.vue"
import acindex from "../views/index/activity/recommand.vue"
import punSuccess from "../views/success/pubsuccess.vue"
import personVerify from "../views/mine/personVerify.vue"
import cerorderdetaiul from "../views/mine/zorderdetail.vue"
import joinsuccess from "../views/success/joinsuccess.vue"

Vue.use(VueRouter)
// 保存原push
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 同理替换replace
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}

const routes = [{
        path: '/',
        name: 'index',
        component: index,
        meta: {
            keepAlive: true
        } // 需要缓存
    },
    {
        path: '/shopIndex',
        name: 'shop',
        component: Shop,
        meta: {
            title: '商家首页'
        }
    },
    {
        path: '/verify',
        name: 'verify',
        component: Verify,
        meta: {
            title: '商家认证'
        }
    },
    {
        path: '/rules',
        name: 'rules',
        component: Rules,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/activity',
        name: 'activity',
        component: Activity,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/addActivity',
        name: 'addActivity',
        component: AddActivity,
        meta: {
            keepAlive: true
        } // 需要缓存
    },
    {
        path: '/zp',
        name: 'zp',
        component: Zp,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/addposition',
        name: 'addposition',
        component: Addposition,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/punSuccess',
        name: 'punSuccess',
        component: pubSuccess,
        meta: {
            title: '发布成功'
        }
    },
    {
        path: '/joinsuccess',
        name: 'joinsuccess',
        component: joinsuccess,
        meta: {
            title: '发布成功'
        }
    },
    {
        path: '/ActivityEdit',
        name: 'acEdit',
        component: acEdit,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/PositionEdit',
        name: 'poEdit',
        component: poEdit,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/Service',
        name: 'service',
        component: Service,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/addService',
        name: 'addService',
        component: addService,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/editService',
        name: 'editService',
        component: editService,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/Company',
        name: 'Company',
        component: Company,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/Resume',
        name: 'Resume',
        component: Resume,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/Acform',
        name: 'Acform',
        component: Acform,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/Acinfo',
        name: 'Acinfo',
        component: Acinfo,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/getCode',
        name: 'getCode',
        component: getCode,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/Channel',
        name: 'Channel',
        component: Channel,
        meta: {
            title: '新势力'
        }
    },
    {
        path: '/searchResult',
        name: 'searchResult',
        component: searchResult,
        meta: {
            title: '搜索结果'
        }
    },
    {
        path: '/signList',
        name: 'signList',
        component: signList,
        meta: {
            title: '活动报名'
        }
    },
    {
        path: '/signDetail',
        name: 'signDetail',
        component: signDetail,
        meta: {
            title: '活动报名详情'
        }
    },
    {
        path: '/signUp',
        name: 'signUp',
        component: signUp,
        meta: {
            title: '活动报名详情'
        }
    },
    {
        path: '/companyIntro',
        name: 'company',
        component: company,
        meta: {
            title: '企业详情'
        }
    },
    {
        path: '/Live',
        name: 'Live',
        component: Live,
        meta: {
            title: '在线学习'
        }
    },
    {
        path: '/livemore',
        name: 'livemore',
        component: livemore,
        meta: {
            title: '在线学习'
        }
    },
    {
        path: '/liveDetail',
        name: 'liveDetail',
        component: liveDetail,
        meta: {
            title: '在线学习'
        }
    },
    {
        path: '/hr',
        name: 'hr',
        component: hr,
        meta: {
            title: '在线学习'
        }
    },
    {
        path: '/coach',
        name: 'coach',
        component: coach,
        meta: {
            title: '在线学习'
        }
    },
    {
        path: '/coachDetail',
        name: 'coachDetail',
        component: coachDetail,
        meta: {
            title: '导师详情'
        }
    },
    {
        path: '/homeSuccess',
        name: 'homeSuccess',
        component: homeSuccess,
        meta: {
            title: '提交成功'
        }
    },
    {
        path: '/certification',
        name: 'certification',
        component: certification,
        meta: {
            title: '提交成功'
        }
    },
    {
        path: '/cerDetail',
        name: 'cerDetail',
        component: cerDetail,
        meta: {
            title: '提交成功'
        }
    },
    {
        path: '/education',
        name: 'education',
        component: education,
        meta: {
            title: '提交成功'
        }
    },
    {
        path: '/eduDetail',
        name: 'eduDetail',
        component: eduDetail,
        meta: {
            title: '提交成功'
        }
    },
    {
        path: '/serviceIndex',
        name: 'serviceIndex',
        component: serviceIndex,
        meta: {
            title: '提交成功'
        }
    },
    {
        path: '/serviceDetail',
        name: 'serviceDetail',
        component: serviceDetail,
        meta: {
            title: '提交成功'
        }
    },
    {
        path: '/bookDetail',
        name: 'bookDetail',
        component: bookDetail,
        meta: {
            title: '图书详情'
        }
    },
    {
        path: '/books',
        name: 'books',
        component: books,
        meta: {
            title: '图书推荐'
        }
    },
    {
        path: '/Recruitment',
        name: 'Recruitment',
        component: Recruitment,
        meta: {
            title: '图书推荐'
        }
    },
    {
        path: '/RecruitmentDetail',
        name: 'RecruitmentDetail',
        component: RecruitmentDetail,
        meta: {
            title: '图书推荐'
        }
    },
    {
        path: '/Companyhr',
        name: 'Companyhr',
        component: Companyhr,
        meta: {
            title: '图书推荐'
        }
    },
    {
        path: '/mine',
        name: 'mine',
        component: mine,
        meta: {
            title: '图书推荐'
        }
    },
    {
        path: '/bookOrderDetail',
        name: 'bookOrderDetail',
        component: bookOrderDetail,
        meta: {
            title: '图书推荐'
        }
    },
    {
        path: '/activityOrderDetail',
        name: 'activityOrderDetail',
        component: activityOrderDetail,
        meta: {
            title: '图书推荐'
        }
    },
    {
        path: '/newsList',
        name: 'newsList',
        component: newsList,
        meta: {
            title: '图书推荐'
        }
    },
    {
        path: '/newsDetail',
        name: 'newsDetail',
        component: newsDetail,
        meta: {
            title: '图书推荐'
        }
    },
    {
        path: '/recommand',
        name: 'recommand',
        component: recommand,
        meta: {
            title: '图书推荐'
        }
    },
    {
        path: '/acindex',
        name: 'acindex',
        component: acindex,
        meta: {
            title: '图书推荐'
        }
    },
    {
        path: '/personVerify',
        name: 'personVerify',
        component: personVerify,
        meta: {
            title: '图书推荐'
        }
    },
    {
        path: '/cerorderdetaiul',
        name: 'cerorderdetaiul',
        component: cerorderdetaiul,
        meta: {
            title: '图书推荐'
        }
    }

]



const router = new VueRouter({
    mode: 'history', // 去掉#
    base: '/',
    routes,
    scrollBehavior(to, from, savedPosition) {
        // 如果是浏览器前进/后退，使用保存的滚动位置
        if (savedPosition) {
            return savedPosition
        } else {
            // 切换新页面，滚动到顶部
            return {
                x: 0,
                y: 0
            }
        }
    }
})

// router.afterEach 改成这样
router.afterEach((to, from) => {
    // 立即滚动到顶部
    window.scrollTo(0, 0)
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0

    // 延迟滚动（等DOM渲染完）
    setTimeout(() => {
        // 尝试多个可能的容器
        const selectors = ['.scrollWrapper', '.app', '.container', '.main-content', '#app' ,'content']
        selectors.forEach(selector => {
            const el = document.querySelector(selector)
            if (el) {
                el.scrollTop = 0
            }
        })
        window.scrollTo(0, 0)
    }, 100)
})

export default router